/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { deviceType, osName } from 'react-device-detect';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { RootState } from 'redux/store';
import MatchedVisasSideBarDesktop from '../components/common/MatchedVisasSideBar/desktop/MatchedVisasSideBar-Desktop';
import FormNotification from '../components/common/FormNotification/FormNotification';
import FormSideBar from '../components/common/FormSideBar/FormSideBar';
import { getFilledForms } from '../api/rest/table_input';

import {
    messageHalfWay,
    messageKeepFilling,
    messageUpdateInput,
} from '../utils/formNotificationFactory';
import { getKeysByTrueValue } from '../utils/getKeysBytrueValue';
import { handleScrollValue } from '../utils/scrollHandling';
import { isEmptyObject } from '../utils/isEmptyObject';
import { shallowEqual } from '../utils/shallowEqual';
import { FormsFactory } from '../utils/formsFactory';
import { getLocation } from '../utils/location';
import { getCookie } from '../utils/cookies';
import { debounce } from '../utils/debounce';

import { formCounterSlice } from 'redux/formCounter';
import api from '../api';
import './formPage.css';
import { FrontendEventProps } from 'api/models/payload/EventsPayload';
import { getFormPath_v2 } from 'utils/getFormPath_v2';
import { getFormPath_perc } from 'utils/getFormPercentage';

//this comp is no longer used
const FormPage = () => {
    const { screen, purpose, showSpouse } = useSelector(
        (state: RootState) => state.formCounter,
        shallowEqual
    );
    const { isAuthenticated } = useSelector((state: RootState) => state.auth, shallowEqual);
    const user = useSelector((state: RootState) => state.user.entity, shallowEqual);

    const { setNumberForms } = formCounterSlice.actions;
    const dispatch = useDispatch();

    const [isFormPartiallyFilled, setIsFormPartiallyFilled] = useState<boolean>(false);
    const [isFormHalfFilled] = useState<boolean>(false);
    const [isHalfMoreFilled, setIsHalfMoreFilled] = useState<boolean>(false);
    const [assessmentScore, setAssessmentScore] = useState<any[]>([]);
    const [filledForms, setFilledForms] = useState<string[]>([]);
    const [isFormDirty, setIsFormDirty] = useState<boolean>(false);
    const [, setScrollTop] = useState(0);

    //  const formPath = getFormPath(purpose);
    const [formPath, setFormPath] = useState(['']);
    const [formPerc, setFormPerc] = useState(['']);
    const currentFormName = formPath[screen - 1];
    const currentFormPerc = formPerc[screen - 1];
    const [queryParameters] = useSearchParams();
    const sessionId = getCookie('JSESSIONID');
    const country: string = getLocation().userCountry;
    const location = useLocation();

    const handleScroll = () => {
        setScrollTop(handleScrollValue());
    };

    const filledFormsUpdate = (): void => {
        getFilledForms().then((res) => {
            if (isEmptyObject(res)) {
                return;
            }
            const filledForms: any[] = getKeysByTrueValue(res);

            setFilledForms(filledForms);
        });
    };

    const FormNotificationMessageHandler = () =>
        screen === 1
            ? messageKeepFilling()
            : isHalfMoreFilled
              ? messageHalfWay()
              : messageUpdateInput();

    const ShowFormNotification = () =>
        (!isFormDirty && screen === 1) || (!isFormPartiallyFilled && isHalfMoreFilled);

    useEffect(() => {
        dispatch(setNumberForms(formPath.length));
        // eslint-disable-next-line
    }, [formPath]);

    useEffect((): void => {
        if (!formPath && filledForms.length === 0 && !filledForms) {
            return;
        }

        const formPathLength: number = formPath.length;
        const isFormCountEven: boolean = formPathLength % 2 === 0;
        const isFormHalfFilled: boolean = isFormCountEven
            ? screen === Math.floor(formPathLength / 2)
            : screen === Math.floor(formPathLength / 2 - 1);

        setIsHalfMoreFilled(isFormHalfFilled);
    }, [filledForms, formPath, screen]);

    const [, setTempSpouseVal] = useState();
    const [, setTempFamVal] = useState();

    useEffect((): void => {
        const tempFormPath = getFormPath_v2(purpose);
        const tempPer = getFormPath_perc(purpose);
        setFormPath(tempFormPath);
        setFormPerc(tempPer);
        window.addEventListener('storage', () => {
            listenForStorage();
        });

        const listenForStorage = () => {
            const tempSpouseVal = JSON.parse(localStorage.getItem('hasSpouse')!);
            setTempSpouseVal(tempSpouseVal);
            const tempFamVal = JSON.parse(localStorage.getItem('hasFamily')!);
            setTempFamVal(tempFamVal);
            const tempFormPath2 = getFormPath_v2(purpose, tempSpouseVal, tempFamVal);
            const tempPer2 = getFormPath_perc(purpose, tempSpouseVal, tempFamVal);
            setFormPath(tempFormPath2);
            setFormPerc(tempPer2);
        };
    }, [purpose]);

    useEffect((): void => {
        if (isAuthenticated) {
            filledFormsUpdate();
        }
    }, [isAuthenticated, currentFormName]);

    useEffect((): void => {
        const fetchBestScoreAssessmentResults = async () => {
            try {
                let res;
                if (user.id) {
                    res = await api.assessment.getTopScore(user.id);
                }

                if (!isEmptyObject(res) && res?.data) {
                    setAssessmentScore(res.data);
                }
            } catch (e) {
                console.error(e);
            }
        };

        fetchBestScoreAssessmentResults();
    }, [user, currentFormName]);

    useEffect(() => {
        const debouncedHandleScroll = debounce(handleScroll, 200);
        const url = location.pathname + `/${currentFormName.toLowerCase().replace(' ', '_')}`;
        const url_params = window.document.referrer
            ? new URL(window.document.referrer).searchParams
            : null;
        const _eventParams: FrontendEventProps = {
            page_url: url,
            os_type: osName,
            country: country,
            user_id: `${user.id}`,
            session_id: sessionId,
            device_type: deviceType,
            page_title: 'confirmation_modal',
            referrer: window.document.referrer,
            user_agent: window.navigator.userAgent,
            anonymousId: localStorage.ajs_anonymous_id?.replaceAll('"', ''),
            utm_source: queryParameters.get('utm_source') || url_params?.get('utm_source') || '',
            utm_medium: queryParameters.get('utm_medium') || url_params?.get('utm_medium') || '',
            utm_campaign:
                queryParameters.get('utm_campaign') || url_params?.get('utm_campaign') || '',
            utm_content: queryParameters.get('utm_content') || url_params?.get('utm_content') || '',
        };
        (async () => {
            const eventName = 'page_view';
            await api.events.frontend_event_post(eventName, _eventParams);
        })();
        window.addEventListener('scroll', debouncedHandleScroll);
        return () => {
            window.removeEventListener('scroll', debouncedHandleScroll);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isFormDirty && screen > 1) {
            setIsFormDirty(true);
        }
        if (!isFormHalfFilled && isHalfMoreFilled) {
            setIsFormPartiallyFilled(true);
        }
    }, [screen, isFormDirty, isFormHalfFilled, isHalfMoreFilled]);

    const currentForm = FormsFactory(currentFormName, showSpouse, currentFormPerc);

    return (
        <div className="formPageContainer">
            {ShowFormNotification() && (
                <FormNotification>{FormNotificationMessageHandler()}</FormNotification>
            )}
            <div className="formWrapper">
                <FormSideBar screen={screen} formPath={formPath} filledForms={filledForms} />
                {currentForm}
                <div className="browser">
                    <MatchedVisasSideBarDesktop assessmentScore={assessmentScore} />
                </div>
                {/*  <MobileView>
                    <MatchedVisasSideBarMobile assessmentScore={assessmentScore} />
                </MobileView> */}
            </div>
        </div>
    );
};

export default FormPage;
